import { Input, SelectNew, TextArea } from "@synthesis/shared-ui";

import { useCreateApplicationDictionariesContext } from "../../create-application-dictionaries-context";
import { toSelectItems } from "../../create-application-page.lib";
import { CreateApplicationFormField, CreateApplicationFormRow, CreateApplicationFormSection } from "../create-application-form-layout";

export const AdjacentObjectConnectionSection = () => {
  const { dictionaries } = useCreateApplicationDictionariesContext();

  return (
    <CreateApplicationFormSection title="Точка примыкания" required>
      <CreateApplicationFormRow>
        <CreateApplicationFormField label="Железная дорога (филиал РЖД)" required>
          <SelectNew
            controlled
            controlledClear
            name="railway"
            placeholder="Выберите из списка"
            items={toSelectItems(dictionaries.railways)}
            required
            size="md"
          />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="Станция / Перегон">
          <Input name="stationSection" placeholder="Например: перегон Одинцово - Галицыно" />
        </CreateApplicationFormField>
      </CreateApplicationFormRow>

      <CreateApplicationFormRow className="lg:grid-cols-3">
        <CreateApplicationFormField label="Км, пикет и метр" optionalHint="(если известно)">
          <Input name="junctionLocation" placeholder="Например: 71 км, ПК 4+50" />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="Координаты" optionalHint="(если известно)">
          <Input name="coordinates" placeholder="Например: 55.7558, 37.6176" />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="Номер пути" optionalHint="(если известно)">
          <Input name="nearestExistingTrack" placeholder="Например: путь №3, стрелочный перевод №12" />
        </CreateApplicationFormField>
      </CreateApplicationFormRow>

      <CreateApplicationFormField label="Комментарий к месту примыкания">
        <TextArea
          name="connectionPlaceComment"
          rows={4}
          placeholder="Дополнительная информация для уточнения местоположения пересечения (при необходимости, например, ориентиры, особенности расположения, уточнения)."
        />
      </CreateApplicationFormField>
    </CreateApplicationFormSection>
  );
};
